import { ReactNode } from 'react';
import { PageHeader } from '@efast_public/fjd-component-library';

interface StaticPageLayoutProps {
  title: string;
  description?: string;
  children?: ReactNode;
}

export default function StaticPageLayout(props: StaticPageLayoutProps) {
  return (
    <>
      <PageHeader text={props.description ?? ''} heading={props.title} />
      {props.children}
    </>
  );
}
